import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';

interface CountingNumberProps {
  target: number;
  duration?: number;
  delay?: number;
  decimals?: number;
  prefix?: string;
  suffix?: string;
  className?: string;
}

/**
 * Counting Animation Component - Using react-countup for smooth digit animations
 * Animates numbers from 0 to target value with optional delay and custom easing
 */
const CountingNumber: React.FC<CountingNumberProps> = ({
  target,
  duration = 1.5,
  delay = 0,
  decimals = 0,
  prefix = '',
  suffix = '',
  className = ''
}) => {
  const [shouldStart, setShouldStart] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldStart(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [delay]);

  return (
    <span className={className}>
      {shouldStart ? (
        <CountUp
          start={0}
          end={target}
          duration={duration}
          decimals={decimals}
          prefix={prefix}
          suffix={suffix}
          separator=","
          useEasing={true}
          easingFn={(t, b, c, d) => {
            // Custom easing function - ease out cubic for smooth deceleration
            return c * ((t = t / d - 1) * t * t + 1) + b;
          }}
        />
      ) : (
        <span>{prefix}0{suffix}</span>
      )}
    </span>
  );
};

export default CountingNumber;
